/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import Cookies from 'js-cookie';
import actions from './actions';

const {
  loginBegin,
  loginSuccess,
  loginErr,
  setAuthTokenBegin,
  setAuthTokenSuccess,
  setAuthTokenErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
} = actions;

const login = () => {
  return async dispatch => {
    try {
      dispatch(setAuthTokenBegin());
      setTimeout(() => {
        Cookies.set('logedIn', true);
        return dispatch(loginSuccess(true));
      }, 1000);
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const setAuthToken = tokenObject => {
  return async dispatch => {
    try {
      dispatch(setAuthTokenBegin());
      return dispatch(setAuthTokenSuccess(tokenObject));
    } catch (err) {
      dispatch(setAuthTokenErr(err));
    }
  };
};

const logOut = () => {
  return async dispatch => {
    try {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');
      dispatch(logoutSuccess(null));
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, setAuthToken, logOut };
